import {getStore} from "trim-redux";
import {ChevronLeft,ChevronRight} from "lucide-react";
import React from "react";
import {getDirection} from "../../../config/design/theme";

const ChevronBack = ({className}) => {
  let dir = getDirection();

  return (
      dir === "rtl" ?
          <ChevronRight className={className}/>
          :
          <ChevronLeft className={className}/>
  );
};

export default ChevronBack;
